"use client";

import { logger } from "@/utils/logger";
import { useEffect } from "react";

export function ServiceWorkerRegistration() {
	useEffect(() => {
		if (typeof window === "undefined") return;
		if (!("serviceWorker" in navigator)) return;

		const registerSW = async () => {
			try {
				// Add version query parameter to prevent caching of service worker
				const version =
					process.env.NEXT_PUBLIC_BUILD_VERSION || process.env.npm_package_version || Date.now().toString();
				const registration = await navigator.serviceWorker.register(`/sw.js?v=${version}`, {
					scope: "/",
				});

				// logger.info("Service Worker registered successfully", {
				// 	scope: registration.scope,
				// });

				// Handle updates - delegate to useVersionCheck hook for consistent UX
				registration.addEventListener("updatefound", () => {
					const newWorker = registration.installing;
					if (newWorker) {
						newWorker.addEventListener("statechange", () => {
							if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
								// New content is available - let useVersionCheck handle the notification
								logger.info("New content available, version check hook will handle notification");
							}
						});
					}
				});

				// Handle offline/online status
				const updateOnlineStatus = () => {
					const condition = navigator.onLine ? "online" : "offline";
					logger.info(`App is ${condition}`);
				};

				window.addEventListener("online", updateOnlineStatus);
				window.addEventListener("offline", updateOnlineStatus);

				return () => {
					window.removeEventListener("online", updateOnlineStatus);
					window.removeEventListener("offline", updateOnlineStatus);
				};
			} catch (error) {
				logger.debug("Service Worker registration failed :", error);
			}
		};

		registerSW();
	}, []);

	return null; // This component doesn't render anything
}
